import { FC, Suspense } from 'react'

import { Cluster, Typography } from '@forto-dev/phoenix-ui-core'

import { useLocalisation } from '@/utils/localisation'

import { useNotifications } from '../hooks/useNotifications'

const NotificationCount = () => {
  const { count } = useNotifications()

  return <Typography color="muted">({count})</Typography>
}

export const NotificationsTitle: FC = () => {
  const { translate } = useLocalisation()

  return (
    <Cluster gap={8} y="baseline">
      <Typography variant="h4">{translate('notifications.title')}</Typography>
      <Suspense>
        <NotificationCount />
      </Suspense>
    </Cluster>
  )
}
